var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2025_4_5_10_57"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yuanben@sentry"]={id:"2025_4_5_10_57"};
      


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 378
// module chunks = 3